/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { toast } from "react-toastify";
import { useSelectLang } from "@hooks/useLang";
import { copyallGameVideos, getGameVideos } from "@api/cms";
import { IMAGE_DOMAIN } from "@constants/api";
import GameVideosModal from "@components/gamevideos/GameVideosModal";
import QuicklyCopySettings from "@components/shared/QuicklyCopySettings";
import { Card, Button, Icon } from "@mui/material";

export default function GameVideosPage() {
  const { lang } = useSelectLang();
  const [gameVideos, setGameVideos] = useState(null);

  const [selectedVideo, setSelectedVideo] = useState(null);

  const getData = async () => {
    const res = await getGameVideos(lang);
    setGameVideos(
      res
        ? res.map((r) => {
          return { ...r, imgUrl: `${IMAGE_DOMAIN}/${r.imagePath}` };
        })
        : []
    );

  };

  useEffect(() => {
    getData();
  }, [lang]);

  const addGameVideo = () => {
    setSelectedVideo({
      isAddNew: true,
      id: -1,
      title: "",
      image: null,
      imgUrl: "",
      language: lang,
      sort: 1,
    });
  };

  const handleCloseModal = async (reGetData) => {
    if (reGetData) await getData();
    setSelectedVideo(null);
  };

  const handleQuicklyCopySubmit = async (toLanguage) => {
    if (!lang || !toLanguage) {
      toast.error("請重新整理網頁後再嘗試");
    } else {
      const res = await copyallGameVideos({ fromLanguage: lang, toLanguage });
      if (res && typeof res === "object" && gameVideos)
        if (res?.length === gameVideos?.length)
          toast.success(`複製到 ${toLanguage} 成功`);
    }
  };

  return (
    <Card
      elevation={3}
      className="w-full overflow-auto"
      style={{ padding: "24px" }}
    >
      <GameVideosPageWrap>
        <QuicklyCopySettings onSubmit={handleQuicklyCopySubmit} />
        遊戲視頻 - 250 x 250（長x寬）。<strong>圖片檔名不可重複</strong>
        <br />
        {`教學：點擊"新增遊戲視頻"按鈕，或者圖片來打開新增/修改視窗。-> 右上角"X"按鈕用於關閉。視窗內最下方的儲存/刪除按鈕提供該名稱所對應的功能。`}

        <Button
          variant="contained"
          color="secondary"
          onClick={addGameVideo}
          mt={10}
        >
          <Icon>add</Icon>&nbsp;
          新增遊戲視頻
        </Button>

        <div className="videos-wrap">
          {gameVideos &&
            gameVideos.map((v) => (
              <div key={v.id} onClick={() => setSelectedVideo(v)}>
                <img src={v.imgUrl} alt={`${v.title}-${v.id}`} />
                <p className="video-title">{v.title}</p>
              </div>
            ))}
        </div>
        <GameVideosModal
          show={selectedVideo !== null}
          item={selectedVideo}
          onClose={handleCloseModal}
        />
      </GameVideosPageWrap>
    </Card>
  );
}

const GameVideosPageWrap = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  .videos-wrap {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 20px;
    width: 100%;
    box-sizing: border-box;

    > div {
      margin: auto 0px;
      width: 200px;
      cursor: pointer;
      > img {
        width: 100%;
        height: auto;
      }
      .video-title {
        text-align: center;
        margin-top: 5px;
        font-size: 14px;
      }
    }
  }

  > button {
    margin: 10px 0px;
    width: 200px;
  }
`;